'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const userAnimationReducedPreference = typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const AnimationReducedPreferenceContext = /*#__PURE__*/ React.createContext(undefined);
const AnimationReducedPreferenceSetter = /*#__PURE__*/ React.createContext(undefined);
export function AnimationReducedPreferenceProvider({ children }) {
    const [animationReduced, setAnimationReduced] = React.useState(userAnimationReducedPreference || false);
    return /*#__PURE__*/ _jsx(AnimationReducedPreferenceContext, {
        value: animationReduced,
        children: /*#__PURE__*/ _jsx(AnimationReducedPreferenceSetter, {
            value: setAnimationReduced,
            children: children
        })
    });
}
export default function useAnimationReduced() {
    const context = React.use(AnimationReducedPreferenceContext);
    if (context === undefined) {
        throw new Error('useAnimationReduced must be used within a AnimationReducedPreferenceProvider');
    }
    return context;
}
export function useSetAnimationReduced() {
    const context = React.use(AnimationReducedPreferenceSetter);
    if (context === undefined) {
        throw new Error('useSetAnimationReduced must be used within a AnimationReducedPreferenceProvider');
    }
    return context;
}
export function useAnimationReducedAtom() {
    return [
        useAnimationReduced(),
        useSetAnimationReduced()
    ];
}

//# sourceMappingURL=animationReducedAtom.js.map